<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :totalData="totalData"
      @reload="reload"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage({ pageSize: 50 })"
      >
        <template #default="{form}">
          <b-form-radio-group
            v-model="displayCurrency"
            :options="displayCurrencyOptions"
            size="sm"
            class="ml-2"
            name="radio-btn-outline"
            button-variant="outline-primary"
            buttons
            @change="reload"
          />

          <el-badge :value="checkedRowCount" :hidden="!checkedRowCount">
            <b-button
              v-if="allow('P')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              :class="{ clearable: !!checkedRowCount }"
              @click="exportFile(form)"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i
                class="el-icon-circle-close"
                @click.stop="clearCheckboxRow()"
              />
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-awsReport-settlement' }"
      :exportOptions="{ params: { searchForm: chooseTemplateOptions.searchForm } }"
      @export-success="clearCheckboxRow()"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChooseTemplate },
  data() {
    return {
      usePage: true,
      totalData: {},
      displayCurrency: '',
      checkedRows: [],
      chooseTemplateOptions: {
        visible: false,
        searchForm: {},
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
    displayCurrencyOptions() {
      return [
        { text: this.$l('btn_displayCurrency_curr') || '本位币', value: '' },
        { text: this.$l('btn_displayCurrency_USD') || '美元', value: 'USD' },
        { text: this.$l('btn_displayCurrency_CNY') || '人民币', value: 'CNY' },
      ]
    },
  },
  methods: {
    async getData(form) {
      this.loading = true
      const res = await Promise.all([
        this.getTableData(form),
        this.getTotalData(form),
      ])
      this.loading = false

      const [tableData, totalData] = res
      this.setData(tableData)
      this.totalData = totalData
    },
    getTableData(form) {
      return this.$api
        .ecomAmzRecordSettlementListApi({
          ...form,
          ...this.page,
          displayCurrency: this.displayCurrency,
        })
        .catch(() => ({}))
    },
    getTotalData(form) {
      return this.$api
        .ecomAmzRecordSettlementTotalApi({
          ...form,
          displayCurrency: this.displayCurrency,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
    exportFile(form = {}) {
      const listRecordCode = this.checkedRows?.map((item) => item.recordCode) || []
      this.chooseTemplateOptions = {
        visible: true,
        searchForm: {
          ...form,
          listRecordCode,
          displayCurrency: this.displayCurrency,
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn {
  .el-icon-circle-close {
    display: none;
  }
}
.btn.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
